import {isNumber} from 'ramda-adjunct';

import {hasKey} from 'shared/web';

import {getRowCellValue, type RowData} from 'features/eag-grid';

import {DIRECT_SALE_ITEMS_GRID_COLUMNS} from '../constants/directSaleItemsGridColumns';
import {getStringCellValue} from './getStringCellValue';

/**
 * Maps direct-sale item grid rows to parts-request items (POST /parts-request). Cell
 * extraction and fallbacks mirror the per-row 'request' action in WorkItemsSegment:
 * the unitPrice cell value is a money object ({amount, currency}), amount defaults to
 * 0 and neededAt/unitPrice stay undefined when absent (both nullish in the schema).
 */
export const mapRowsToPartsRequestItems = (rows: RowData[], directSaleId: string) =>
  rows.map((row) => {
    const unitPrice = getRowCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.unitPrice);
    const amount = getRowCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.amount);

    return {
      originEntityId: row.id,
      articleId: getStringCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.articleId) ?? '',
      originEntityHeaderType: 'direct-sale' as const,
      originEntityHeaderId: directSaleId,
      itemNeededAtDate: getStringCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.neededAt),
      proposedSalePrice:
        hasKey(unitPrice, 'amount') && isNumber(unitPrice.amount) ? unitPrice.amount : undefined,
      quantity: isNumber(amount) ? amount : 0,
    };
  });
